import { render } from "./rbqm_barchart.vue?vue&type=template&id=15632c46&scoped=true"
import script from "./rbqm_barchart.vue?vue&type=script&lang=js"
export * from "./rbqm_barchart.vue?vue&type=script&lang=js"

import "./rbqm_barchart.vue?vue&type=style&index=0&id=15632c46&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15632c46"]])

export default __exports__